import React from 'react';
import { Button, Spinner } from 'react-bootstrap';
import ReactTooltip from 'react-tooltip';
import Check from '../../../icons/Check';
import Edit from '../../../icons/Edit';

interface MessageInputEditButtonProps {
  onClick: () => void;
  canEdit: boolean;
  loading: boolean;
  id: string;
}

function MessageInputEditButton({
  onClick,
  canEdit,
  loading,
  id,
}: MessageInputEditButtonProps) {
  return (
    <div
      data-tip={canEdit ? 'Save changes' : 'Edit message'}
      data-for={`edit-button-${id}`}
      data-cy={`message-input-edit-button-${id}`}
    >
      <Button
        onClick={onClick}
        variant={canEdit ? 'success' : 'primary'}
        disabled={loading}
      >
        {loading && (
          <Spinner animation="border" role="status" size="sm">
            <span className="visually-hidden">Loading...</span>
          </Spinner>
        )}
        {canEdit && !loading && <Check fill="white" />}
        {!canEdit && !loading && <Edit fill="white" />}
      </Button>
      <ReactTooltip
        id={`edit-button-${id}`}
        effect="solid"
        className="smalltooltip"
      />
    </div>
  );
}

export default MessageInputEditButton;
